import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from 'src/util/axios-instance';
import {
  ReorderSingleContentRequestParams,
  ReorderSingleContentResponseData
} from './interfaces/reorderSingleContent.interface';

export const reorderSingleContent = async (
  params: ReorderSingleContentRequestParams
): Promise<ReorderSingleContentResponseData> => {
  const { projectId, body } = params;

  const response = await api.put<ReorderSingleContentResponseData>(
    `${API_URL}/v1/project/${projectId}/content/reorder/single`,
    body,
    { headers: { 'x-session-id': getCachedSessionId() } }
  );

  return response.data;
};
